var exports = {
  "w": "comment-indicator__5AA1Za",
  "Y": "in-progress-comment-indicator__669RMo",
};

module.exports = exports;
